import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

export default function RequireRoles({ allow = [], requireSubscription = false }) {
  const { currentUser, loading, roles, isAdmin, hasFullAccess, subscription } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-700 bg-white dark:text-slate-200 dark:bg-[#050816]">
        <div className="animate-spin h-8 w-8 border-t-2 border-yellow-500 rounded-full" />
      </div>
    );
  }

  if (!currentUser) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // Staff bypass for role and subscription checks (Admin, Specialist, Mentor)
  if (hasFullAccess) {
    return <Outlet />;
  }

  // Specific role check
  const allowedRoles = allow.map(r => String(r).toLowerCase().trim());
  const hasRole = roles.some(r => allowedRoles.includes(String(r).toLowerCase().trim()));

  if (allow.length > 0 && !hasRole) {
    return <Navigate to="/unauthorized" replace />;
  }

  // Subscription check (if required)
  if (requireSubscription && !subscription.isActive) {
    // Redirect to appropriate page based on subscription status
    if (subscription.status === "past_due") {
      // Payment issue - show update payment prompt
      return <Navigate to="/subscription/manage" replace state={{ from: location, reason: "past_due" }} />;
    }

    // No subscription - show upgrade prompt
    return <Navigate to="/subscribe" replace state={{ from: location }} />;
  }

  return <Outlet />;
}
